import { useEffect, useState } from 'react';

const EVENT = 'surplify:breadcrumb';
let current = null;

export const setBreadcrumbTitle = (title) => {
  current = title || null;
  window.dispatchEvent(new Event(EVENT));
};

export const useBreadcrumbTitle = (title) => {
  useEffect(() => {
    setBreadcrumbTitle(title);
    return () => setBreadcrumbTitle(null);
  }, [title]);
};

export const useCurrentBreadcrumbTitle = () => {
  const [title, setTitle] = useState(current);
  useEffect(() => {
    const h = () => setTitle(current);
    window.addEventListener(EVENT, h);
    return () => window.removeEventListener(EVENT, h);
  }, []);
  return title;
};
